import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["applicationId"],
  _excluded2 = ["metadata"],
  _excluded3 = ["metadata"],
  _excluded4 = ["clientApplicationRequestId"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import moment from "moment";
import Vue from "vue";
import { updateField } from "@joandvgv/vuex-map-fields";
import { fillArrays, getApplicationDefaultValueOnAddition, getApplicationWithDefaults, getApplicationWithDefaultsForPage, sanitizeInputs, toggleApplicationSchemeColumnAsRequired, validateApplicationPath } from "@Shared/utils/utils";
import DefaultApplicationValuesState from "@Broker/@Modules/clients/applications/application/store/application-default-values-state";
import { DEFAULT_AMORTIZATION_YEARS_VALUE, DEFAULT_LOAN_TYPE_VALUE } from "@Shared/@Utils/application-defaults-utils/application-default-values-constants";
import { cloneDeep, get, groupBy, invert, isEmpty, kebabCase, merge, set } from "lodash";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
export const SET_CURRENT_APPLICATION = "SET_CURRENT_APPLICATION";
export const UPDATE_APPLICATION_DETAILS = "UPDATE_APPLICATION_DETAILS";
export const UPDATE_APPLICATION_KEY = "UPDATE_APPLICATION_KEY";
export const SET_CLIENT_DETAILS = "SET_CLIENT_DETAILS";
export const SET_CLIENT_USERNAME = "SET_CLIENT_USERNAME";
export const ADD_CLIENT_APPLICATION = "ADD_CLIENT_APPLICATION";
export const SET_APPLICATION_DATA = "SET_APPLICATION_DATA";
export const SET_REPLICATED_DATA = "SET_REPLICATED_DATA";
export const SET_SCHEMA = "SET_SCHEMA";
export const SET_CUSTOMIZATION_SCHEMA = "SET_CUSTOMIZATION_SCHEMA";
export const SET_IS_DEFAULT_CUSTOMIZATION_SCHEMA = "SET_IS_DEFAULT_CUSTOMIZATION_SCHEMA";
export const SET_EMPTY_APPLICATION = "SET_EMPTY_APPLICATION";
export const SET_VISIBILITY_CURRENT_APPLICATION = "SET_VISIBILITY_CURRENT_APPLICATION";
export const CLEAR_CURRENT_SCHEMA = "CLEAR_CURRENT_SCHEMA";
export const SET_CALCULATIONS_DATA = "SET_CALCULATIONS_DATA";
export const SET_CLIENT_REQUEST_EMAIL = "SET_CLIENT_REQUEST_EMAIL";
export const SET_REQUEST_DATA_DETAILS = "SET_REQUEST_DATA_DETAILS";
export const SET_APPLICANT_OTHER_PROPERTIES = "SET_APPLICANT_OTHER_PROPERTIES";
export const REDIRECT_TO_CLIENT = "REDIRECT_TO_CLIENT";
export const TOGGLE_APPLICATION_LOCK_STATUS = "TOGGLE_APPLICATION_LOCK_STATUS";
export const SET_APPLICATION_LOCK_STATUS = "SET_APPLICATION_LOCK_STATUS";
export const TOGGLE_APPLICATION_SAVING_STATUS = "TOGGLE_APPLICATION_SAVING_STATUS";
export const REMOVE_APPLICATION_PAGE_DATA = "REMOVE_APPLICATION_PAGE_DATA";
export const INSERT_APPLICATION_GROUP_ITEM = "INSERT_APPLICATION_GROUP_ITEM";
export const SET_APPLICATION_GROUP_ITEM = "SET_APPLICATION_GROUP_ITEM";
export const REMOVE_APPLICATION_GROUP_ITEM = "REMOVE_APPLICATION_GROUP_ITEM";
export const REPLICATE_APPLICATION_GROUP_ITEM = "REPLICATE_APPLICATION_GROUP_ITEM";
export const SET_CALCULATED_VALUES = "SET_CALCULATED_VALUES";
export const SET_CALCULATED_VALUES_LOADING_STATUS = "SET_CALCULATED_VALUES_LOADING_STATUS";
export const SET_CURRENT_APPLICATION_UPDATED_TIME = "SET_CURRENT_APPLICATION_UPDATED_TIME";
export const REPLICATE_APPLICATION_ADDRESS = "REPLICATE_APPLICATION_ADDRESS";
export const SET_APPLICANT_INDEX = "SET_APPLICANT_INDEX";
export const SET_PROPERTY_ORDER = "SET_PROPERTY_ORDER";
export const TOGGLE_FIELD_VISIBILITY = "TOGGLE_FIELD_VISIBILITY";
export const TOGGLE_FIELD_VALIDATION = "TOGGLE_FIELD_VALIDATION";
export const TOGGLE_FIELD_CUSTOMIZATION = "TOGGLE_FIELD_CUSTOMIZATION";
export const TOGGLE_SCHEMA_SAVING_STATUS = "TOGGLE_SCHEMA_SAVING_STATUS";
export const TOGGLE_SCHEMA_RESETTING_STATUS = "TOGGLE_SCHEMA_RESETTING_STATUS";
export const SET_APPLICATION_READ_STATUS = "SET_APPLICATION_READ_STATUS";
export const SET_MORTGAGE_INDEX = "SET_MORTGAGE_INDEX";
export const PUSH_MORTGAGE_SUBMISSION = "PUSH_MORTGAGE_SUBMISSION";
export const RESET_MORTGAGE_INFORMATION = "RESET_MORTGAGE_INFORMATION";
export const RESET_SUBMISSION_INFORMATION = "RESET_SUBMISSION_INFORMATION";
export const CHANGE_MORTGAGE_INDEX = "CHANGE_MORTGAGE_INDEX";
export const UPDATE_SUBMISSION_INSURED = "UPDATE_SUBMISSION_INSURED";
export const UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE = "UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE";
export const UPDATE_QUALIFYING_INTEREST_RATE = "UPDATE_QUALIFYING_INTEREST_RATE";
export const MIRROR_SUBMISSION_AND_QUALIFYING = "MIRROR_SUBMISSION_AND_QUALIFYING";
export const UPDATE_INTEREST_ONLY = "UPDATE_INTEREST_ONLY";
export const MARK_APPLICATION_GROUP_VISIBILITY = "MARK_APPLICATION_GROUP_VISIBILITY";
export const UPDATE_AMORTIZATION_YEARS = "UPDATE_AMORTIZATION_YEARS";
export const SET_APPLICATION_SUBMISSION_AGENT = "SET_APPLICATION_SUBMISSION_AGENT";
export const E_SIGNATURE_SET_DOCUMENTS = "E_SIGNATURE_SET_DOCUMENTS";
export const E_SIGNATURE_SET_REQUESTED_SIGNATURES = "E_SIGNATURE_SET_REQUESTED_SIGNATURES";
export const E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT = "E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT";
export const SET_APPLICATION_OWNER = "SET_APPLICATION_OWNER";
export const SET_MORTGAGE_LENDER = "SET_MORTGAGE_LENDER";
export const SET_FILOGIX_DEALS = "SET_FILOGIX_DEALS";
export const SET_FILOGIX_DEAL_STATUS = "SET_FILOGIX_DEAL_STATUS";
export const SET_FILOGIX_SUBMITTING = "SET_FILOGIX_SUBMITTING";
export const SET_E_SIGN_TEMPLATES = "SET_E_SIGN_TEMPLATES";
export const UPDATE_E_SIGN_TEMPLATE = "UPDATE_E_SIGN_TEMPLATE";
export const ADD_E_SIGN_TEMPLATE = "ADD_E_SIGN_TEMPLATE";
export const E_SIGN_REMOVE_TEMPLATE = "E_SIGN_REMOVE_TEMPLATE";
export const REMOVE_APPLICATION = "REMOVE_APPLICATION";
export const SET_MUTED_AUTOMATIONS = "SET_MUTED_AUTOMATIONS";
export const SET_APPLICATION_SUBSCRIPTION_INFO = "SET_APPLICATION_SUBSCRIPTION_INFO";
export const SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE = "SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE";
export const REQUEST_PACKAGE_SET_REQUESTED_PACKAGES = "REQUEST_PACKAGE_SET_REQUESTED_PACKAGES";
export const SET_CLIENT_OWNER = "SET_CLIENT_OWNER";
export const SET_APPLICATION_SYNC_STATUS = "SET_APPLICATION_SYNC_STATUS";
export const SET_APPLICATION_SYNCABLE_STATUS = "SET_APPLICATION_SYNCABLE_STATUS";
export const DELETE_ALL_PROPERTY_EXISTING_MORTGAGES = "DELETE_ALL_PROPERTY_EXISTING_MORTGAGES";
export const SET_APPLICATION_REFERRAL_SOURCE = "SET_APPLICATION_REFERRAL_SOURCE";
export const SET_APPLICATION_VALIDATIONS = "SET_APPLICATION_VALIDATIONS";
export const SET_ERD_SYNC_LOADING = "SET_ERD_SYNC_LOADING";
export const SET_ERD_SYNC_INTERVAL_ID = "SET_ERD_SYNC_INTERVAL_ID";
export const SET_ERD_SYNC_PREVIOUS_LOAD_STATUS = "SET_ERD_SYNC_PREVIOUS_LOAD_STATUS";
export const SWITCH_PREVIOUS_ADDRESS_TO_CURRENT = "SWITCH_PREVIOUS_ADDRESS_TO_CURRENT";
export const SET_CURRENT_APPLICATION_ID = "SET_CURRENT_APPLICATION_ID";
export const SET_GENERATED_LENDER_NOTE = "SET_GENERATED_LENDER_NOTE";
export const SET_WAITING_FOR_GENERATED_LENDER_NOTE = "SET_WAITING_FOR_GENERATED_LENDER_NOTE";
export const SET_APPLICANT_MORTGAGE_EXCLUSION = "SET_APPLICANT_MORTGAGE_EXCLUSION";
export const SET_DEAL_TYPE = "SET_DEAL_TYPE";
export const UPDATE_EMPLOYMENT_ORDER = "UPDATE_EMPLOYMENT_ORDER";
export const SET_INSURANCE_SUBMISSION_HISTORY = "SET_INSURANCE_SUBMISSION_HISTORY";
export const SET_INSURANCE_PROVIDERS = "SET_INSURANCE_PROVIDERS";
const mapPath = path => {
  var _context, _context2;
  return _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = path.split("[")).call(_context2, item => item.replace("]", ""))).call(_context, item => isNaN(_parseInt(item)));
};
export default {
  [UPDATE_APPLICATION_KEY]: (state, {
    key,
    value
  }) => {
    state[key] = value;
  },
  [SET_INSURANCE_SUBMISSION_HISTORY]: (state, submissionsHistory) => {
    state.insuranceSubmissionsHistory = submissionsHistory;
  },
  [SET_INSURANCE_PROVIDERS]: (state, insuranceProviders) => {
    state.insuranceProviders = insuranceProviders;
  },
  [SET_GENERATED_LENDER_NOTE]: (state, newNote) => {
    state.generatedLenderNote = newNote;
  },
  [SET_WAITING_FOR_GENERATED_LENDER_NOTE]: (state, value) => {
    state.waitingForGeneratedLenderNote = value;
  },
  [SET_SCHEMA]: (state, data) => {
    state.schema = data;
  },
  [SET_CUSTOMIZATION_SCHEMA]: (state, data) => {
    state.customizationSchema = data;
  },
  [SET_IS_DEFAULT_CUSTOMIZATION_SCHEMA]: (state, {
    isDefaultSchema
  }) => {
    state.customizationSchema.isDefaultSchema = isDefaultSchema;
  },
  [SET_EMPTY_APPLICATION]: (state, {
    flow,
    emptyApplication
  }) => {
    state.emptyApplication[flow] = emptyApplication;
  },
  [SET_CURRENT_APPLICATION_UPDATED_TIME]: (state, {
    applicationId,
    updatedAt
  }) => {
    Vue.set(state.applications.byId[applicationId], "updatedAt", updatedAt);
  },
  [SET_CURRENT_APPLICATION]: (state, {
    applicationId,
    application,
    emptyApplication
  }) => {
    var _context3;
    let emptyToUse = fillArrays(emptyApplication, application);
    const filledApplication = merge(emptyToUse, application);
    const currentApplication = state.applications.byId[applicationId] || {};
    const applicationObject = _objectSpread(_objectSpread({}, currentApplication), filledApplication);
    const applicationObjectWithDefaults = getApplicationWithDefaults(applicationObject, DefaultApplicationValuesState);
    Vue.set(state.applications.byId, applicationId, applicationObjectWithDefaults);
    if (!_includesInstanceProperty(_context3 = state.applications.allIds).call(_context3, applicationId)) {
      state.applications.allIds.push(applicationId);
    }
  },
  [SET_PROPERTY_ORDER]: (state, {
    path,
    order
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    get(currentApplication, path).order = order;
  },
  [UPDATE_APPLICATION_DETAILS]: (state, _ref) => {
    let {
        applicationId
      } = _ref,
      details = _objectWithoutProperties(_ref, _excluded);
    Vue.set(state.applications.byId, applicationId, _objectSpread(_objectSpread({}, state.applications.byId[applicationId]), details));
  },
  [CLEAR_CURRENT_SCHEMA]: state => {
    state.schema = {
      metadata: {},
      "purchase-approval": [],
      "purchase-preapproval": [],
      "refinance-approval": [],
      "switch-transfer": []
    };
    state.emptyApplication = {
      "purchase-approval": {},
      "purchase-preapproval": {},
      "refinance-approval": {},
      "switch-transfer": {}
    };
  },
  [SET_VISIBILITY_CURRENT_APPLICATION]: (state, {
    flow
  }) => {
    state.currentApplicationId = null;
    Vue.set(state.applications.byId, "null", _objectSpread(_objectSpread({}, cloneDeep(state.emptyApplication)[flow]), {}, {
      flow
    }));
  },
  [TOGGLE_FIELD_CUSTOMIZATION]: (state, {
    paths,
    customization,
    multi,
    isVisible
  }) => {
    const {
      currentApplicationId,
      customizationSchema
    } = state;
    const validCustomizations = _Object$keys(customizationSchema[validateApplicationPath(paths[0])]);
    if (!_includesInstanceProperty(validCustomizations).call(validCustomizations, customization)) throw new Error("Invalid Schema Customization Type");
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const flow = currentApplication.flow;
    paths.forEach((path, index) => {
      const processedPath = validateApplicationPath(path);
      let value = !customizationSchema[processedPath][customization][flow];
      // if there's more than 1 path, it's a toggler, thus we need to override to the first path value
      if (paths.length > 1 && index) value = customizationSchema[validateApplicationPath(paths[0])][customization][flow];
      // if multiple, don't perform toggle, but an actual visible value. This just support multi visible not multi required
      if (multi) value = isVisible;
      customizationSchema[processedPath][customization][flow] = value;
    });
  },
  [TOGGLE_FIELD_VISIBILITY]: (state, {
    paths,
    isVisible
  }) => {
    const _state$schema = state.schema,
      {
        metadata
      } = _state$schema,
      schemaWithFlows = _objectWithoutProperties(_state$schema, _excluded2);
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const flow = currentApplication.flow;
    const schema = schemaWithFlows[flow];
    const [mainPath] = paths;
    const mappedPath = mapPath(mainPath);
    const [section, group, fieldKey, subGroupKey = ""] = mappedPath;
    let keysToCompare = [];
    if (paths.length) {
      keysToCompare = _mapInstanceProperty(paths).call(paths, path => {
        const mapped = mapPath(path);
        const key = mapped.pop();
        const group = mapped.pop();
        return {
          key,
          group
        };
      });
    } else {
      keysToCompare.push({
        key: fieldKey || subGroupKey
      });
    }
    const {
      sections: allSections
    } = _findInstanceProperty(schema).call(schema, ({
      key
    }) => key === section);
    const groupSections = groupBy(allSections, "group")[group];
    if (!fieldKey) {
      groupSections.forEach(group => {
        group.visible = !group.visible;
      });
      return;
    }
    const matchedKeys = [];
    keysToCompare.forEach(({
      key: keyToCompare,
      group: groupToCompare
    }) => {
      groupSections.forEach(section => {
        const columns = subGroupKey ? metadata["group-rules"][groupToCompare].columns : section.columns;
        const column = _findInstanceProperty(columns).call(columns, column => column.key === keyToCompare && !_includesInstanceProperty(matchedKeys).call(matchedKeys, keyToCompare));
        if (column) {
          matchedKeys.push(keyToCompare);
          //Since we use dependencies, it's not an actual toggle
          if (typeof column.visible === "object") {
            column.visible[flow] = !isVisible;
          } else {
            column.visible = !isVisible;
          }
        }
        const allHidden = columns.every(({
          visible
        }) => {
          if (typeof visible === "object") {
            return !visible[flow];
          }
          return !visible;
        });
        const differentSection = subGroupKey && section.columns !== groupToCompare;
        if (allHidden && !differentSection) {
          section.visible = false;
        } else if (!differentSection) {
          section.visible = true;
        }
      });
    });
  },
  [TOGGLE_FIELD_VALIDATION]: (state, {
    paths,
    isRequired
  }) => {
    const _state$schema2 = state.schema,
      {
        metadata
      } = _state$schema2,
      schemaWithFlows = _objectWithoutProperties(_state$schema2, _excluded3);
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const flow = currentApplication.flow;
    const schema = schemaWithFlows[flow];
    const [mainPath] = paths;
    const mappedPath = mapPath(mainPath);
    const [section, group, fieldKey, subGroupKey = ""] = mappedPath;
    let keysToCompare = [];
    if (paths.length) {
      keysToCompare = _mapInstanceProperty(paths).call(paths, path => {
        const mapped = mapPath(path);
        const key = mapped.pop();
        const group = mapped.pop();
        return {
          key,
          group
        };
      });
    } else {
      keysToCompare.push({
        key: fieldKey || subGroupKey
      });
    }
    const {
      sections: allSections
    } = _findInstanceProperty(schema).call(schema, ({
      key
    }) => key === section);
    const groupSections = groupBy(allSections, "group")[group];
    if (!fieldKey) {
      //If there is no fieldKey found, then we are "most likely" toggling a whole section
      groupSections.forEach(group => {
        var _context4;
        group.columns = _mapInstanceProperty(_context4 = group.columns).call(_context4, column => {
          return toggleApplicationSchemeColumnAsRequired(column, isRequired, flow);
        });
      });
      return;
    }
    keysToCompare.forEach(({
      key: keyToCompare,
      group: groupToCompare
    }) => {
      _findInstanceProperty(groupSections).call(groupSections, section => {
        const columns = subGroupKey ? metadata["group-rules"][groupToCompare].columns : section.columns;
        const column = _findInstanceProperty(columns).call(columns, column => column.key === keyToCompare);
        return toggleApplicationSchemeColumnAsRequired(column, isRequired, flow);
      });
    });
  },
  [SET_CLIENT_DETAILS]: (state, {
    clientUsername,
    clientData,
    applications
  }) => {
    if (clientData) {
      Vue.set(state.clients, clientUsername, _objectSpread(_objectSpread({}, state.clients[clientUsername]), clientData));
    }
    if (applications) {
      Vue.set(state.clients, clientUsername, _objectSpread(_objectSpread({}, state.clients[clientUsername]), {}, {
        applications
      }));
    }
  },
  [ADD_CLIENT_APPLICATION]: (state, {
    clientUsername,
    applicationId,
    applicationData
  }) => {
    state.clients[clientUsername].applications.byId = _objectSpread(_objectSpread({}, state.clients[clientUsername].applications.byId), {}, {
      [applicationId]: applicationData
    });
    state.clients[clientUsername].applications.allIds = [...state.clients[clientUsername].applications.allIds, applicationId];
  },
  [PUSH_MORTGAGE_SUBMISSION]: (state, {
    index,
    structure
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const parsedMortgageType = invert(MORTGAGE_TYPE_PARSER)[index];
    const clonedStructure = cloneDeep(structure);
    clonedStructure["submission-details"]["mortgage-type"] = parsedMortgageType;
    const noMortgageType = currentApplication["submission-details"].every(submission => !submission["submission-details"]["mortgage-type"]);
    if (noMortgageType) {
      currentApplication["submission-details"][0]["submission-details"]["mortgage-type"] = parsedMortgageType;
      currentApplication["submission-details"][0]["submission-details"]["loan-type"] = currentApplication["submission-details"][0]["submission-details"]["loan-type"] || DEFAULT_LOAN_TYPE_VALUE;
    } else {
      clonedStructure["qualifying-details"]["amortization-years"] = DEFAULT_AMORTIZATION_YEARS_VALUE;
      clonedStructure["submission-details"]["amortization-years"] = DEFAULT_AMORTIZATION_YEARS_VALUE;
      currentApplication["submission-details"].push(clonedStructure);
    }
  },
  [UPDATE_SUBMISSION_INSURED]: (state, {
    index,
    value
  }) => {
    var _context5;
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const parsedMortgageType = invert(MORTGAGE_TYPE_PARSER)[index];
    const currentSubmissionMortgage = _findInstanceProperty(_context5 = currentApplication["submission-details"]).call(_context5, submission => submission["submission-details"]["mortgage-type"] === parsedMortgageType);
    if (currentSubmissionMortgage && currentSubmissionMortgage["submission-details"]) {
      currentSubmissionMortgage["submission-details"].insured = value;
    }
  },
  [UPDATE_SUBMISSION_INCLUDE_INSURANCE_IN_MORTGAGE]: (state, {
    index,
    value
  }) => {
    var _context6;
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const parsedMortgageType = invert(MORTGAGE_TYPE_PARSER)[index];
    const currentSubmissionMortgage = _findInstanceProperty(_context6 = currentApplication["submission-details"]).call(_context6, submission => submission["submission-details"]["mortgage-type"] === parsedMortgageType);
    if (currentSubmissionMortgage && currentSubmissionMortgage["submission-details"]) {
      currentSubmissionMortgage["submission-details"]["include-in-mortgage"] = value;
    }
  },
  [UPDATE_QUALIFYING_INTEREST_RATE]: (state, {
    submissionIndex,
    value
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    currentApplication["submission-details"][submissionIndex]["qualifying-details"]["interest-rate"] = value;
  },
  [SET_APPLICANT_MORTGAGE_EXCLUSION]: (state, {
    submissionIndex,
    value
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    currentApplication["submission-details"][submissionIndex]["applicant-submission-exclusion"] = value;
  },
  [CHANGE_MORTGAGE_INDEX]: (state, {
    currentMortgageType,
    newMortgageType
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const currentApp = currentApplication;
    const parsedMortgageTo = MORTGAGE_TYPE_PARSER[newMortgageType];
    const parsedMortgageFrom = MORTGAGE_TYPE_PARSER[currentMortgageType];
    const mortgages = currentApp["mortgage-details"].mortgages;
    if (mortgages[parsedMortgageTo]) {
      var _context7;
      for (const key in mortgages[parsedMortgageTo]) {
        mortgages[parsedMortgageTo][key] = mortgages[parsedMortgageFrom][key];
      }
      for (const key in mortgages[parsedMortgageFrom]) {
        mortgages[parsedMortgageFrom][key] = null;
        mortgages[parsedMortgageFrom]["amount"] = 0;
      }
      const currentSubmission = _findIndexInstanceProperty(_context7 = currentApp["submission-details"]).call(_context7, submission => submission["submission-details"]["mortgage-type"] === currentMortgageType);
      currentApp["submission-details"][currentSubmission]["submission-details"]["mortgage-type"] = newMortgageType;
    }
  },
  [RESET_MORTGAGE_INFORMATION]: (state, {
    index,
    structure
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    currentApplication["mortgage-details"].mortgages[index] = structure;
  },
  [RESET_SUBMISSION_INFORMATION]: (state, {
    index,
    structure
  }) => {
    const {
      currentApplicationId
    } = state;
    Vue.set(state.applications.byId[currentApplicationId]["submission-details"], index, structure);
  },
  [SET_CALCULATIONS_DATA]: (state, {
    calculations
  }) => {
    state.calculations = calculations;
  },
  [SET_CALCULATED_VALUES]: (state, {
    calculations
  }) => {
    state.calculatedValues = calculations;
  },
  [SET_CALCULATED_VALUES_LOADING_STATUS]: (state, {
    loading
  }) => {
    state.calculatedValues = _objectSpread(_objectSpread({}, state.calculatedValues), {}, {
      loading
    });
  },
  [SET_APPLICANT_OTHER_PROPERTIES]: (state, {
    applicant,
    properties
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    get(currentApplication, applicant)["other-properties"] = properties;
  },
  [SET_APPLICANT_INDEX]: state => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId];
    const {
      "co-applicants": coapps,
      "main-applicant": mainApp
    } = currentApplication;
    if (!coapps) return;
    const mainAppProperties = mainApp["other-properties"] || [];
    for (const property of mainAppProperties) {
      property.applicantIndex = 0;
    }
    coapps.forEach((coapp, index) => {
      const coappOtherProperties = coapp["other-properties"] || [];
      for (const property of coappOtherProperties) {
        property.applicantIndex = index + 1;
      }
    });
  },
  [SET_CLIENT_REQUEST_EMAIL]: (state, {
    clientRequestEmail
  }) => {
    state.clientRequestEmail = clientRequestEmail;
  },
  [SET_REQUEST_DATA_DETAILS]: (state, {
    requestDataEmail,
    requestDataName
  }) => {
    state.requestDataEmail = requestDataEmail;
    state.requestDataName = requestDataName;
  },
  [REDIRECT_TO_CLIENT]: (state, {
    clientUsername,
    applicationId
  }) => {
    const {
      currentRoute
    } = Vue.router;
    const clientUsernameChanged = clientUsername && clientUsername !== currentRoute.params.clientUsername;
    const applicationIdChanged = applicationId && applicationId !== currentRoute.params.applicationId;
    if (clientUsernameChanged || applicationIdChanged) {
      const clientUsernameToUse = clientUsername || currentRoute.params.clientUsername;
      const applicationIdToUse = applicationId || currentRoute.params.applicationId;
      Vue.router.replace({
        name: "application",
        params: _objectSpread(_objectSpread({}, currentRoute.params), {}, {
          clientUsername: clientUsernameToUse,
          applicationId: applicationIdToUse,
          ignoreStateChange: true
        })
      });
    }
  },
  [SET_APPLICATION_LOCK_STATUS]: (state, {
    locked
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "locked", locked);
  },
  [TOGGLE_APPLICATION_LOCK_STATUS]: state => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "locked", !currentApplication.locked);
  },
  [SET_APPLICATION_READ_STATUS]: (state, {
    read
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "read", read);
  },
  [SET_APPLICATION_SUBMISSION_AGENT]: (state, {
    submissionAgentId
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "submissionAgentId", submissionAgentId);
  },
  [SET_APPLICATION_REFERRAL_SOURCE]: (state, {
    referrerId
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "referrerId", referrerId);
  },
  [SET_APPLICATION_OWNER]: (state, {
    appOwnerDetails
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "appOwnerDetails", appOwnerDetails);
  },
  [TOGGLE_APPLICATION_SAVING_STATUS]: (state, {
    saving
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(currentApplication, "saving", saving);
  },
  [TOGGLE_SCHEMA_SAVING_STATUS]: (state, {
    saving,
    error = false
  }) => {
    state.schema = _objectSpread(_objectSpread({}, state.schema), {}, {
      saving
    });
    if (!saving && !error) {
      state.schema = _objectSpread(_objectSpread({}, state.schema), {}, {
        metadata: _objectSpread(_objectSpread({}, state.schema.metadata), {}, {
          updatedAt: moment()
        })
      });
      state.customizationSchema = _objectSpread(_objectSpread({}, state.customizationSchema), {}, {
        updatedAt: moment()
      });
    }
  },
  [TOGGLE_SCHEMA_RESETTING_STATUS]: (state, {
    resetting,
    error = false
  }) => {
    state.schema = _objectSpread(_objectSpread({}, state.schema), {}, {
      resetting
    });
    if (!resetting && !error) {
      state.schema = _objectSpread(_objectSpread({}, state.schema), {}, {
        metadata: _objectSpread(_objectSpread({}, state.schema.metadata), {}, {
          updatedAt: moment()
        })
      });
    }
  },
  [SET_APPLICATION_GROUP_ITEM]: (state, {
    what,
    where,
    amountItems = 1
  }) => {
    const amountToAdd = _Array$from({
      length: amountItems
    }, () => cloneDeep(what));
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const applicationObject = cloneDeep(currentApplication);
    set(applicationObject, where, amountToAdd);
    const applicationObjectWithDefaults = getApplicationDefaultValueOnAddition({
      what,
      where
    }, applicationObject, DefaultApplicationValuesState);
    Vue.set(state.applications.byId, currentApplicationId, applicationObjectWithDefaults);
  },
  [SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE]: (state, {
    page,
    triggerOnSave = false
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const applicationObject = cloneDeep(currentApplication);
    const applicationObjectWithDefaults = getApplicationWithDefaultsForPage(page, applicationObject, DefaultApplicationValuesState, {
      triggerOnSave
    });
    Vue.set(state.applications.byId, currentApplicationId, applicationObjectWithDefaults);
  },
  [INSERT_APPLICATION_GROUP_ITEM]: (state, {
    what,
    where,
    amountItems = 1
  }) => {
    const amountToAdd = _Array$from({
      length: amountItems
    }, () => cloneDeep(what));
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const applicationObject = cloneDeep(currentApplication);
    const currentApplicationItem = get(applicationObject, where);
    currentApplicationItem.push(...amountToAdd);
    const applicationObjectWithDefaults = getApplicationDefaultValueOnAddition({
      what,
      where
    }, applicationObject, DefaultApplicationValuesState);
    Vue.set(state.applications.byId, currentApplicationId, applicationObjectWithDefaults);
  },
  [REMOVE_APPLICATION_GROUP_ITEM]: (state, {
    index,
    where,
    startEmpty
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const currentApplicationGroup = get(currentApplication, where);
    const emptyApplication = cloneDeep(state.emptyApplication[currentApplication.flow]);
    const currentFirstOneVisible = currentApplicationGroup[0].groupSetVisible;
    if (index === 0 && currentApplicationGroup[1]) {
      currentApplicationGroup[1].groupSetVisible = currentFirstOneVisible;
    }
    if (currentApplicationGroup.length === 1 && startEmpty) {
      const whereDefault = where.replace(/\[[1-9]\d*\]/, "[0]");
      const defaultApplicationGroup = get(emptyApplication, whereDefault)[0];
      defaultApplicationGroup.groupSetVisible = false;
      return Vue.set(get(currentApplication, where), 0, defaultApplicationGroup);
    }
    _spliceInstanceProperty(currentApplicationGroup).call(currentApplicationGroup, index, 1);
  },
  [REMOVE_APPLICATION_PAGE_DATA]: (state, {
    page
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const emptyApplication = cloneDeep(state.emptyApplication)[currentApplication.flow];
    Vue.set(state.applications.byId, currentApplicationId, _objectSpread(_objectSpread({}, currentApplication), {}, {
      [page]: emptyApplication[page]
    }));
  },
  [MARK_APPLICATION_GROUP_VISIBILITY]: (state, {
    where,
    visibility
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    Vue.set(get(currentApplication, where)[0], "groupSetVisible", visibility);
  },
  [REPLICATE_APPLICATION_ADDRESS]: state => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const mainApplicantAddress = currentApplication["main-applicant"]["personal-details"]["addresses"][0];
    if (!mainApplicantAddress) return;
    for (const key in mainApplicantAddress) {
      currentApplication["co-applicants"][0]["personal-details"]["addresses"][0][key] = mainApplicantAddress[key];
    }
  },
  [REPLICATE_APPLICATION_GROUP_ITEM]: (state, {
    path,
    index,
    targetPath,
    targetIndex,
    key
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const group = get(currentApplication, path);
    const groupToReplicate = index != null ? _objectSpread(_objectSpread({}, group[index]), {}, {
      replicated: {
        path,
        index,
        targetPath,
        targetIndex
      }
    }) : _objectSpread(_objectSpread({}, group), {}, {
      path,
      targetPath,
      key
    });
    if (targetIndex != null) {
      Vue.set(get(currentApplication, targetPath), targetIndex, groupToReplicate);
    } else {
      get(currentApplication, targetPath)[key] = groupToReplicate;
    }
  },
  [E_SIGNATURE_SET_DOCUMENTS]: async (state, {
    availableDocuments
  }) => {
    state.eSign = _objectSpread(_objectSpread({}, state.eSign), {}, {
      availableDocuments: {
        byId: availableDocuments.byId,
        allIds: availableDocuments.allIds
      }
    });
  },
  [E_SIGNATURE_SET_REQUESTED_SIGNATURES]: async (state, {
    clientApplicationRequests
  }) => {
    state.eSign = _objectSpread(_objectSpread({}, state.eSign), {}, {
      clientApplicationRequests: {
        byId: clientApplicationRequests.byId,
        allIds: clientApplicationRequests.allIds
      }
    });
  },
  [E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT]: async (state, _ref2) => {
    let {
        clientApplicationRequestId
      } = _ref2,
      values = _objectWithoutProperties(_ref2, _excluded4);
    state.eSign.clientApplicationRequests.byId[clientApplicationRequestId] = _objectSpread(_objectSpread({}, state.eSign.clientApplicationRequests.byId[clientApplicationRequestId]), values);
  },
  [MIRROR_SUBMISSION_AND_QUALIFYING]: (state, {
    value,
    submissionIndex,
    key
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    currentApplication["submission-details"][submissionIndex]["submission-details"][key] = value;
    currentApplication["submission-details"][submissionIndex]["qualifying-details"][key] = value;
  },
  updateField,
  setDetails: (state, {
    param: mainPath,
    value,
    path
  }) => {
    var _context8;
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const field = {
      path: _mapInstanceProperty(_context8 = path.split(".")).call(_context8, item => {
        const regex = /([[0-9\]])/g;
        const key = item.replace(regex, "");
        const match = item.match(regex);
        const position = match ? match.join("") : "";
        return kebabCase(key) + position;
      }).join("."),
      value: sanitizeInputs({
        [path]: value
      }, {
        upperFirst: true
      })[path]
    };
    const details = get(currentApplication, mainPath);
    updateField(details, field);
  },
  setSubmissionDetails: (state, {
    param: mainPath,
    value,
    path
  }) => {
    const details = get(state, mainPath);
    const field = {
      path,
      value
    };
    updateField(details, field);
  },
  setManualSubmissionMortgage: (state, field) => {
    var _state$submissionManu;
    const currentSubmissionId = state.currentManualResponseId;
    updateField((_state$submissionManu = state.submissionManualResponse.byId[currentSubmissionId]) == null ? void 0 : _state$submissionManu.mortgage, field);
  },
  setManualSubmissionDeal: (state, field) => {
    var _state$submissionManu2;
    const currentSubmissionId = state.currentManualResponseId;
    updateField((_state$submissionManu2 = state.submissionManualResponse.byId[currentSubmissionId]) == null ? void 0 : _state$submissionManu2.deal, field);
  },
  setManualSubmissionResponse: (state, field) => {
    var _state$submissionManu3;
    const currentSubmissionId = state.currentManualResponseId;
    updateField((_state$submissionManu3 = state.submissionManualResponse.byId[currentSubmissionId]) == null ? void 0 : _state$submissionManu3.response, field);
  },
  [SET_MORTGAGE_LENDER]: async (state, {
    mortgageType,
    lenderName
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    currentApplication["submission-details"][mortgageType]["submission-details"].lender = lenderName;
  },
  [SET_FILOGIX_DEALS]: async (state, {
    filogixSubmissions,
    applicationId
  }) => {
    Vue.set(state.filogix.submissions.byApplication, applicationId, filogixSubmissions);
  },
  [SET_FILOGIX_DEAL_STATUS]: async (state, {
    filogixSubmissionId,
    applicationId,
    status
  }) => {
    Vue.set(state.filogix.submissions.byApplication[applicationId].byId[filogixSubmissionId], "status", status);
  },
  [SET_FILOGIX_SUBMITTING]: async (state, {
    applicationId,
    submitting
  }) => {
    const current = state.filogix.pendingSubmissions.byApplication[applicationId] || {};
    Vue.set(state.filogix.pendingSubmissions.byApplication, applicationId, _objectSpread(_objectSpread({}, current), {}, {
      submitting
    }));
  },
  [SET_ERD_SYNC_LOADING]: async (state, {
    applicationId,
    loading
  }) => {
    const current = state.filogix.updatingSyncStatus.byApplication[applicationId] || {};
    Vue.set(state.filogix.updatingSyncStatus.byApplication, applicationId, _objectSpread(_objectSpread({}, current), {}, {
      loading
    }));
  },
  [SET_ERD_SYNC_INTERVAL_ID]: async (state, {
    applicationId,
    intervalId
  }) => {
    const current = state.filogix.updatingSyncStatus.byApplication[applicationId] || {};
    Vue.set(state.filogix.updatingSyncStatus.byApplication, applicationId, _objectSpread(_objectSpread({}, current), {}, {
      intervalId
    }));
  },
  [SET_ERD_SYNC_PREVIOUS_LOAD_STATUS]: async (state, {
    applicationId,
    previousLoadStatus
  }) => {
    const current = state.filogix.updatingSyncStatus.byApplication[applicationId] || {};
    Vue.set(state.filogix.updatingSyncStatus.byApplication, applicationId, _objectSpread(_objectSpread({}, current), {}, {
      previousLoadStatus
    }));
  },
  [SET_E_SIGN_TEMPLATES]: (state, {
    templates
  }) => {
    state.eSign = _objectSpread(_objectSpread({}, state.eSign), {}, {
      templates: {
        byId: templates.byId,
        allIds: templates.allIds
      }
    });
  },
  [ADD_E_SIGN_TEMPLATE]: (state, template) => {
    const byId = state.eSign.templates.byId;
    const allIds = state.eSign.templates.allIds;
    allIds.push(template.eSignTemplateId);
    state.eSign.templates = {
      allIds,
      byId: _objectSpread(_objectSpread({}, byId), {}, {
        [template.eSignTemplateId]: template
      })
    };
  },
  [UPDATE_E_SIGN_TEMPLATE]: (state, template) => {
    state.eSign.templates.byId[template.eSignTemplateId] = template;
  },
  [E_SIGN_REMOVE_TEMPLATE]: (state, eSignTemplateId) => {
    const allIds = state.eSign.templates.allIds;
    Vue.delete(state.eSign.templates.byId, eSignTemplateId);
    state.eSign.templates.allIds = _filterInstanceProperty(allIds).call(allIds, currenteSignTemplateId => currenteSignTemplateId !== eSignTemplateId);
  },
  [REMOVE_APPLICATION]: (state, {
    applicationId,
    clientUsername
  }) => {
    var _context9, _state$clients$client;
    Vue.delete(state.applications.byId, applicationId);
    state.applications.allIds = _filterInstanceProperty(_context9 = state.applications.allIds).call(_context9, appId => appId !== applicationId) || [];
    if ((_state$clients$client = state.clients[clientUsername]) != null && _state$clients$client.applications.byId[applicationId]) {
      var _state$clients$client2;
      Vue.delete((_state$clients$client2 = state.clients[clientUsername]) == null ? void 0 : _state$clients$client2.applications.byId, applicationId);
    }
  },
  [SET_MUTED_AUTOMATIONS]: (state, {
    mutedAutomations,
    applicationId
  }) => {
    Vue.set(state.mutedAutomations.byApplication, applicationId, mutedAutomations);
  },
  [SET_APPLICATION_SUBSCRIPTION_INFO]: (state, {
    subscription
  }) => {
    const {
      currentApplicationId
    } = state;
    Vue.set(state.applications.byId[currentApplicationId], "subscription", subscription);
  },
  [REQUEST_PACKAGE_SET_REQUESTED_PACKAGES]: async (state, {
    applicationId,
    requestedPackages
  }) => {
    Vue.set(state.requestedPackages.byApplication, applicationId, requestedPackages);
  },
  [SET_CLIENT_OWNER]: async (state, {
    clientUsername,
    agentUsername
  }) => {
    var _state$clients$client3;
    const clientApplications = ((_state$clients$client3 = state.clients[clientUsername]) == null ? void 0 : _state$clients$client3.applications.byId) || {};
    _Object$values(clientApplications).forEach(application => {
      Vue.set(application, "agentUsername", agentUsername);
    });
  },
  [SET_APPLICATION_SYNC_STATUS]: (state, {
    applicationId,
    status
  }) => {
    Vue.set(state.applications.byId[applicationId], "sync", _objectSpread(_objectSpread({}, state.applications.byId[applicationId].sync), status));
  },
  [SET_APPLICATION_SYNCABLE_STATUS]: (state, {
    applicationId,
    syncable
  }) => {
    Vue.set(state.applications.byId[applicationId], "syncable", syncable);
  },
  [DELETE_ALL_PROPERTY_EXISTING_MORTGAGES]: state => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const currentFlow = currentApplication.flow;
    const emptyExistingMortgages = state.emptyApplication[currentFlow].property["existing-mortgages"];
    Vue.set(currentApplication.property, "existing-mortgages", cloneDeep(emptyExistingMortgages));
  },
  [SET_APPLICATION_VALIDATIONS]: (state, {
    validations
  }) => {
    Vue.set(state, "applicationValidations", validations);
  },
  [SWITCH_PREVIOUS_ADDRESS_TO_CURRENT]: (state, {
    index,
    path
  }) => {
    const {
      currentApplicationId
    } = state;
    const currentApplication = state.applications.byId[currentApplicationId] || {};
    const applicationObject = cloneDeep(currentApplication);
    const applicant = get(applicationObject, path);
    const addresses = applicant["personal-details"]["addresses"];
    if (!isEmpty(addresses[0].replicated)) addresses[0].replicated = null;
    const temp = addresses[index];
    addresses[index] = addresses[0];
    addresses[0] = temp;
    Vue.set(get(state.applications.byId[currentApplicationId], `${path}[personal-details]`), "addresses", addresses);
  },
  [SET_CURRENT_APPLICATION_ID]: (state, {
    applicationId
  }) => {
    Vue.set(state, "currentApplicationId", isNaN(applicationId) ? applicationId : _parseInt(applicationId));
  },
  [SET_DEAL_TYPE]: state => {
    state.lenderSubmissionData.dealType = "";
  },
  [UPDATE_EMPLOYMENT_ORDER]: (state, {
    employment,
    path
  }) => {
    const {
      currentApplicationId
    } = state;
    Vue.set(get(state.applications.byId[currentApplicationId], path), "employment", employment);
  }
};